// src/App.js
import React, { useState, useEffect } from 'react';
import { auth, loginWithGoogle, logout } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import Dashboard from './pages/Dashboard';
import Tracker from './pages/Tracker';
import NuevoProyecto from './pages/NuevoProyecto';
import CerebroIA from './pages/CerebroIA';
import Drive from './pages/Drive';
import Login from './pages/Login';
import './App.css';

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState('dashboard');
  const [proyectoActivo, setProyectoActivo] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#0D1B2A' }}>
      <div style={{ textAlign:'center', color:'white' }}>
        <div className="loader"></div>
        <p style={{ marginTop:16, color:'#8BA0B5', fontFamily:'system-ui' }}>Cargando ARCSEG Portal...</p>
      </div>
    </div>
  );

  if (!user) return <Login onLogin={loginWithGoogle} />;

  const esUsuarioCorporativo = [
    'esegovia@arcseg-ec.com',
    'ssegovia@arcseg-ec.com',
    'asegovia@arcseg-ec.com'
  ].includes(user.email);

  if (!esUsuarioCorporativo) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#0D1B2A' }}>
      <div style={{ background:'#1A2E44', padding:40, borderRadius:12, textAlign:'center', maxWidth:400 }}>
        <div style={{ fontSize:40, marginBottom:16 }}>🔒</div>
        <h2 style={{ color:'white', marginBottom:8 }}>Acceso restringido</h2>
        <p style={{ color:'#8BA0B5' }}>Este portal es exclusivo para el equipo ARCSEG. Usa tu cuenta corporativa @arcseg-ec.com</p>
        <button onClick={logout} style={{ marginTop:24, padding:'10px 24px', background:'#E8863A', color:'white', border:'none', borderRadius:8, cursor:'pointer', fontWeight:600 }}>
          Cerrar sesión
        </button>
      </div>
    </div>
  );

  const renderPage = () => {
    switch(activePage) {
      case 'dashboard': return <Dashboard setActivePage={setActivePage} setProyectoActivo={setProyectoActivo} />;
      case 'tracker':   return <Tracker proyectoActivo={proyectoActivo} setProyectoActivo={setProyectoActivo} />;
      case 'nuevo':     return <NuevoProyecto setActivePage={setActivePage} />;
      case 'cerebro':   return <CerebroIA />;
      case 'drive':     return <Drive />;
      default:          return <Dashboard setActivePage={setActivePage} setProyectoActivo={setProyectoActivo} />;
    }
  };

  return (
    <div className="app-layout">
      <Sidebar activePage={activePage} setActivePage={setActivePage} user={user} onLogout={logout} />
      <main className="app-main">
        {renderPage()}
      </main>
    </div>
  );
}

function Sidebar({ activePage, setActivePage, user, onLogout }) {
  const navItems = [
    { id: 'dashboard', icon: '📊', label: 'Dashboard' },
    { id: 'tracker',   icon: '📁', label: 'Proyectos' },
    { id: 'drive',     icon: '📂', label: 'Drive' },
    { id: 'cerebro',   icon: '🧠', label: 'Cerebro IA' },
    { id: 'nuevo',     icon: '+',  label: 'Nuevo Proyecto' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <img src="/logo.png" alt="ARCSEG" style={{ width:36, height:36, borderRadius:8, objectFit:'contain', background:'transparent' }} />
        <div>
          <div className="logo-name">ARCSEG</div>
          <div className="logo-sub">Portal Interno</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map(item => (
          <button
            key={item.id}
            className={`nav-item ${activePage === item.id ? 'active' : ''}`}
            onClick={() => setActivePage(item.id)}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          {user.photoURL
            ? <img src={user.photoURL} alt="" className="user-avatar" />
            : <div className="user-avatar-placeholder">{user.displayName?.[0] || 'U'}</div>
          }
          <div>
            <div className="user-name">{user.displayName?.split(' ')[0] || 'Usuario'}</div>
            <div className="user-email">{user.email}</div>
          </div>
        </div>
        <button className="logout-btn" onClick={onLogout} title="Cerrar sesión">⏻</button>
      </div>
    </aside>
  );
}
